/* import __COLOCATED_TEMPLATE__ from './stale-keep-active.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action, getProperties } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { dropTask } from 'ember-concurrency';
import { closeModal, showNextModal } from 'sh-www/utils/modal-controls';
import { validateSchema } from 'sh-www/utils/validators';
import { handleErrorResponse } from 'sh-www/utils/handles-errors';
import { string, object } from 'yup';
import ProjectStaleModal from 'sh-www/components/modals/project/stale';

const SCHEMA = object({
  'reason': string().required('You must provide a reason.')
    .min(5, 'Reason must be at least 5 characters.'),
});

const FORM_INPUTS = ['reason', 'generic-exception'];

class ProjectStaleKeepActiveModalComponent extends Component {
  @service('commands.application-commands') applicationCommandService;
  @service('state-managers.application') applicationStateManager;

  @tracked reason = '';
  @tracked errors = {};

  get submitDisabled() {
    return this.handleSubmit.isRunning || !this.reason;
  }

  @action
  onReasonChange(value) {
    this.reason = value;
  }

  @action
  onBackClicked() {
    const { application, reloadApplicationCallback } = this.args.model;

    showNextModal(this, ProjectStaleModal, {
      application,
      reloadApplicationCallback,
    })
  }

  @dropTask
  *handleSubmit() {
    try {
      const [_, validationErrors = {}] = validateSchema(getProperties(this, Object.keys(SCHEMA.fields)), SCHEMA);
      this.errors = validationErrors;

      if (Object.values(this.errors).every(error => !error)) {
        yield this.applicationCommandService.markStillActive(this.args.model.application, this.reason);
        this.applicationStateManager.addToast('Project marked active');
        closeModal(this);
      }
    } catch (error) {
      handleErrorResponse(this, error, FORM_INPUTS, false);
    }
  }
}

export default ProjectStaleKeepActiveModalComponent;
